import { type ButtonHTMLAttributes } from 'react';
import { ChevronRightIcon } from '@zep-us/zus-icons';
import { cn } from '@/utils';
type AiBuilderActionChipProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  attentionActive?: boolean;
  emoji?: string;
  label: string;
};
export const AiBuilderActionChip = ({
  attentionActive = false,
  emoji,
  label,
  className,
  type = 'button',
  ...buttonProps
}: AiBuilderActionChipProps) => {
  return <button type={type} className={cn('group flex min-h-10 min-w-0 max-w-[min(416px,100%)] items-center gap-2xs overflow-hidden rounded-md border border-opacity-assistive bg-neutral py-xs pl-md pr-xs text-body-md-semibold text-default transition-[background-color,border-color,margin,color] duration-150 ease-out hover:mr-3xs hover:bg-alternative focus-visible:bg-alternative focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-strong focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:bg-neutral disabled:text-disabled', attentionActive && 'mr-3xs bg-alternative motion-reduce:transition-none', className)} {...buttonProps} data-sentry-component="AiBuilderActionChip" data-sentry-source-file="AiBuilderActionChip.tsx">
      {emoji && <span aria-hidden="true" className="flex-none leading-none">
          {emoji}
        </span>}
      <span className="min-w-0 flex-1 whitespace-normal break-words text-left">
        {label}
      </span>
      <span className="flex size-lg flex-none items-center justify-center">
        <ChevronRightIcon size="sm" className="text-neutral transition-colors duration-150 ease-out group-hover:text-default group-focus-visible:text-default group-disabled:text-disabled" data-sentry-element="ChevronRightIcon" data-sentry-source-file="AiBuilderActionChip.tsx" />
      </span>
    </button>;
};